import { ChangeEvent, FC, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { costCategoryData, costCategoryDataLoading, ikaMapData, ikaMapDataLoading } from "../../../../reducer/mappingFiles/selectors";
import { Paper, Table, TableContainer, TableHead, TableCell, TableRow, Checkbox, TableBody } from "@mui/material";
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { grey, red, blue } from '@mui/material/colors';
import { ICostCategoriesMap, IIKAMap } from "../../../../reducer/mappingFiles/_interfaces";
import { IMIUIColumn } from "../../../../reducer/General/_interfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { setCostCategoriesMapData } from "../../../../actions/CostCategoriesMapping/ikamapActions";

const tableHeadColour = '#F2F2F2';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

//Material UI Styles
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: tableHeadColour,
        color: theme.palette.common.black,
        fontWeight: 600,
        cursor: 'pointer',
        padding: '0px',
        zIndex: 1
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: '2px 0px'
    },
    // [`&:hover`]: {
    //     backgroundColor: "blue !important"
    // },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    [`&:hover`]: {
        backgroundColor: "white !important"
    },
}));

type IProps = {
    columns: IMIUIColumn[];
    formId: string;
    adminIds?: string[];
    handleEdit: (item:ICostCategoriesMap) => void;
}

export const IKAMapTable:FC<IProps> = ({columns, formId, adminIds, handleEdit}) => {
    const dispatch = useDispatch();
    const data:ICostCategoriesMap[] = useSelector(costCategoryData);
    const dataLoading = useSelector(costCategoryDataLoading);

    const [masterChecked, setMasterChecked] = useState<boolean>(false);

    
    const onMasterCheck = (e:ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setMasterChecked(checked);
        dispatch(setCostCategoriesMapData(data.map((each) => ({...each, checked}))));
    }

    const onItemCheck = (e:ChangeEvent<HTMLInputElement>, row:ICostCategoriesMap) => {
        const newItems = data.map((each) => ({
            ...each,
            checked: each.id === row.id ? e.target.checked : each.checked
        }));

        dispatch(setCostCategoriesMapData(newItems));
        setMasterChecked(newItems.filter(({checked}) => checked).length === data.length);
    }
    

    const handleEditClick = (row:ICostCategoriesMap) => {
        handleEdit(row);
    }


    if (data.length === 0 && !dataLoading) {
        return (
            <div className="table-data-note">
                <p>No data found.</p>
            </div>
        )
    } else if (data.length > 0 && !dataLoading) {
        return (
            <div className="brand-category-table-container">
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <StyledTableRow className="bold-font">
                                <StyledTableCell>
                                    <Checkbox id="mastercheck" checked={masterChecked} onChange={onMasterCheck}
                                        {...label}
                                        size="small"
                                        sx={{
                                            '& .MuiSvgIcon-root': { fontSize: 20 },
                                            color: grey[500],
                                            '&.Mui-checked': {
                                                color: red[500],
                                            },
                                        }}
                                    />
                                </StyledTableCell>
                                {
                                    columns.map((column) => (
                                        <StyledTableCell
                                            key={column.id}
                                            align={column.align}
                                            style={column.id == 'action' ? { position: 'sticky', right: 1, minWidth: column.minWidth, overflow: 'hidden', zIndex:1 } : { minWidth: column.minWidth }}
                                            title="Click and wait to Sort"
                                        >
                                            {column.label}
                                        </StyledTableCell>
                                    ))
                                }
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row:ICostCategoriesMap) => (
                                <StyledTableRow hover role="checkbox" tabIndex={-1} key={`${row.id}_${row.checked}`}>
                                    <StyledTableCell>
                                        <Checkbox
                                            id="rowcheck{row.dim_company_id}"
                                            onChange={(e) => onItemCheck(e, row)}
                                            {...label}
                                            checked={row.checked}
                                            defaultChecked={row.checked}
                                            size="small"
                                            sx={{
                                                '& .MuiSvgIcon-root': { fontSize: 20 },
                                                color: grey[500],
                                                '&.Mui-checked': {
                                                    color: red[500],
                                                },
                                            }} />
                                    </StyledTableCell>
                                    {columns.map((column) => {
                                        const value = row[column.id as keyof ICostCategoriesMap];
                                        return (
                                            <StyledTableCell key={`${column.id}_${row.id}`} align={column.align}
                                                style={column.id === 'action' ?
                                                    { position: 'sticky', right: 1, backgroundColor: 'white', overflow: 'hidden', color: '#E61C2A', minWidth: column.minWidth } :
                                                    { minWidth: column.minWidth, minHeight: '10px' }}
                                            >
                                                {column.id === "action" && adminIds?.includes(formId)
                                                    ? <FontAwesomeIcon icon={faEdit} size="1x" onClick={() => handleEditClick(row)} />
                                                    : value
                                                }
                                            </StyledTableCell>
                                        );
                                    })}
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            </div>
        )
    }

    return <></>
}
